import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  OnInit,
  ViewChild
} from "@angular/core";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {StockItemPropertyFormComponent} from "../stock-item-property/stock-item-property-form/stock-item-property-form.component";
import {Property} from "../../../shared/view-model/core/property.type";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";
import {ProductFormComponent} from "../../product/product-form/product-form.component";
import {appInjector} from "../../../index";
import {PropertyService} from "../../services/property-service/property.service";
import {StockItemCategory} from "../../model/stock-item-catgegory.type";
import {MedicineFormComponent} from "../../medicine/medicine-form/medicine-form.component";
import {StockItemCategoryService} from "../../services/stock-item-category.service";
import {helpTexts} from "../../helptexts";

@Component({
  selector: 'vb-stock-item-form',
  templateUrl: './stock-item-form.component.html',
  styleUrls: ['./stock-item-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => StockItemFormComponent)}]
})
export class StockItemFormComponent extends AbstractVisbosControl<StockItem, FormGroup> implements OnInit, AfterViewChecked, AfterViewInit {

  @ViewChild(MedicineFormComponent)
  medicineForm: MedicineFormComponent;

  helpText;

  propertyAppendix;

  propertyShortAppendix;
  properties: Property[] = [];

  categories: StockItemCategory[];
  propertyInit = StockItemPropertyFormComponent.initControl;

  constructor(fb: FormBuilder, private propertyService: PropertyService, private catService: StockItemCategoryService, cd: ChangeDetectorRef) {
    super(fb, cd, null);
    this.helpText = helpTexts;
  }

  ngOnInit() {
    super.ngOnInit();

    this.dataSubscriptions.push(this.propertyService.getPropertiesList().subscribe((props: any) => this.properties = props));
    this.dataSubscriptions.push(this.catService.getStockItemCategories().subscribe((cats: any) => this.categories = cats));

    this.buildLabels();
  }

  ngAfterViewChecked() {
    this.buildLabels();
    this.onSelectCategory(this.control.get('category_id').value);
    this.cd.detectChanges();
  }

  public buildControlContent(values?: StockItem): FormGroup {
    return StockItemFormComponent.initControl(this.fb, values);
  }

  public static initControl(fb: FormBuilder = null, values?: StockItem): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    let ProdCtrl = ProductFormComponent.initControl(fb);

    let ctrl = fb.group({
      cuid: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      name: [null, Validators.required],
      short_name: [null],
      category_id: [null],
      account_id: [null],
      is_asset_packing: [false],
      reference_stock_master_id: [null],
      stock_master_id: [null],
      visbos_article_number: [null],
      properties: fb.array([]),
      products: fb.array([ProdCtrl], Validators.required),
      keywords: fb.array([]),
    });

    return ctrl;
  }

  public setDefaultValues(item?: StockItem): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name'),
      short_name: this.setValue(item, 'short_name'),
      is_asset_packing: this.setValue(item, 'is_asset_packing'),
      visbos_article_number: this.setValue(item, 'visbos_article_number'),
      category_id: this.setValue(item, 'category.cuid'),
      reference_stock_master_id: this.setValue(item, 'reference_stock_master_id'),
      stock_master_id: this.setValue(item, 'stock_item_master.cuid'),
    }
  };

  buildLabels() {
    if (!(this.control && this.control.get('properties'))) {
      this.propertyAppendix = null;
      this.propertyShortAppendix = null;
      return;
    }

    if (this.control.get('properties').valid) {
      let string: string[] = [];
      let shortString: string[] = [];
      let properties = this.control.get('properties').value;

      for (let prop of properties) {
        let property = this.getPropertyByCuid(prop.property_id);
        if (property) {
          string.push(property.name + " = " + prop.value);
          shortString.push(property.short_name + " " + prop.value);
        }
      }

      this.propertyAppendix = string.join(", ");
      this.propertyShortAppendix = shortString.join(", ");

      this.cd.detectChanges();
    }

  }

  getPropertyByCuid(cuid: string): Property {
    if (this.properties) {
      return this.properties.find(p => p.cuid == cuid);
    } else {
      return null;
    }
  }

  onSelectCategory(categoryCuid: string) {

    let cat;

    if (this.categories) {
      cat = this.categories.find(c => c.cuid == categoryCuid);
    }

    if (cat && cat.name == 'Medikament') {
      this.addMedicineForm();
    } else {
      this.control.removeControl('medicine');
    }

  }

  addMedicineForm() {
    let ctrl = MedicineFormComponent.initControl(this.fb);
    ctrl.removeControl('name'); // Remove control, so it is not displayed
    this.control.addControl('medicine', ctrl);
  }

  addProduct() {
    let ctrl = ProductFormComponent.initControl(this.fb);
    (<FormArray>this.control.get('products')).push(ctrl);
  }

  deleteProduct(index) {
    (<FormArray>this.control.get('products')).removeAt(index);
  }

  reset(fullReset: boolean = false) {
    if (fullReset) {
      (<FormArray>this.control.get('properties')).controls = [];
    }

    this.propertyAppendix = null;
    this.propertyShortAppendix = null;

    super.reset(fullReset);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock-item/stock-item-form/stock-item-form.component.ts